import { render, staticRenderFns } from "./m-goal-task-list.vue?vue&type=template&id=6c9b79c4&"
import script from "./m-goal-task-list.vue?vue&type=script&setup=true&lang=js&"
export * from "./m-goal-task-list.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports